var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"flex":"1","width":"100%"},attrs:{"id":_vm.chartID}})}
var staticRenderFns = []

export { render, staticRenderFns }